import { render, staticRenderFns } from "./area_xwzz.vue?vue&type=template&id=71edddcd&scoped=true"
import script from "./area_xwzz.vue?vue&type=script&lang=js"
export * from "./area_xwzz.vue?vue&type=script&lang=js"
import style0 from "./area_xwzz.vue?vue&type=style&index=0&id=71edddcd&prod&lang=less"
import style1 from "./area_xwzz.vue?vue&type=style&index=1&id=71edddcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edddcd",
  null
  
)

export default component.exports